const BeeCustom = {

    init: function()
    {
        gsap.registerPlugin(ScrollTrigger);
        gsap.defaults({ease: "none", overwrite: true});
        this.setListeners();
    },
    isIndex: function(){
        return document.body.classList.contains('template-index');
    },
    setListeners: function()
    {
        const triggerSubmenu = document.querySelectorAll('.main-menu a.menu-item-has-children');
        if( triggerSubmenu.length )
        {
            [].slice.call(triggerSubmenu).map(function(el){
                el.addEventListener('click', function(e){
                    e.preventDefault();
                    this.classList.toggle('active');
                    return false;
                }, false);
            });
        }

        const triggerMenu = document.querySelector('.trigger-menu-btn');
        if( triggerMenu )
        {
            triggerMenu.addEventListener('click', function(e){
                document.body.classList.toggle('menu-open')
            }, false);
        }


        if( this.isIndex() ){
            const t0 = gsap.timeline({
                scrollTrigger: {
                    trigger: "body",
                    scrub: true,
                    start: 0,
                    end: "+=" + window.innerHeight,
                    pin: false, 
                    markers: false
                }
            });
            t0.add("mani")
            .fromTo(".animated-intro .level-2",{
                "transform": "translateX(0px) rotate(0deg)"
            },{
                "transform": "translateX(-50%) rotate(20deg)"
            },"mani")
            .fromTo(".animated-intro .level-4",{
                "transform": "translateX(0px) rotate(0deg)"
            },{
                "transform": "translateX(50%) rotate(-20deg)"
            },"mani");

            const t1 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".pizzette",
                    scrub: true,
                    start: "top bottom",
                    end: "bottom top",
                    pin: false, 
                    markers: false
                }
            });
            t1.add("pizzette").fromTo(".pizzette",{
                "background-position-x": "100%"
            },{
                "background-position-x": "0"
            },"pizzette");

            const t2 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".divider-omino",
                    scrub: true,
                    start: "top bottom",
                    end: "+=" + window.innerHeight,
                    pin: false, 
                    markers: false
                }
            });
            t2.fromTo(".divider-omino",{
                "transform": "rotate(45deg)"
            },{
                "transform": "rotate(0deg)"
            });


            const t3 = gsap.timeline({
                scrollTrigger: {
                    trigger: ".delivery",
                    scrub: true,
                    start: "top bottom",
                    end: "+=" + (window.innerHeight / 1.5),
                    pin: false, 
                    markers: false
                }
            });
            t3.fromTo(".delivery-header .omino",{
                "transform": "translateX(100%)"
            },{
                "transform": "translateX(0)"
            });
        }
    }

}
BeeCustom.init();